import React, { useEffect } from 'react';

// Lightweight dynamic SEO head — updates <title>, meta, canonical, JSON-LD per route
// (No external helmet dependency; Google renders JS-updated head tags.)

const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== 'content') el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute('content', attrs.content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const upsertJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

const applyHead = ({ title, description, keywords, canonical, jsonLd, jsonLdId }) => {
  if (title) {
    document.title = title;
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
  }
  if (description) {
    upsertMeta('meta[name="description"]', { name: 'description', content: description });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
  }
  if (keywords) {
    upsertMeta('meta[name="keywords"]', { name: 'keywords', content: keywords });
  }
  if (canonical) {
    upsertLink('canonical', canonical);
    upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonical });
  }
  if (jsonLd) {
    upsertJsonLd(jsonLdId, jsonLd);
  }
};

const SEOHead = ({ title, description, keywords, canonical, jsonLd, jsonLdId = 'page-jsonld' }) => {
  useEffect(() => {
    applyHead({ title, description, keywords, canonical, jsonLd, jsonLdId });
  }, [title, description, keywords, canonical, jsonLd, jsonLdId]);

  return null;
};

export default SEOHead;
